import { FC } from 'react';
import { ClassicButton, ErrorBox, Modal } from 'components';
import styled from 'styled-components';
import { VARIANT } from 'components/Buttons/ClassicButton';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { openModal } from 'store/modalSlice';
import { ErrorIcon } from 'assets/icons';

const CopyToModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2.5rem 3.125rem;
  height: calc(100% - 9rem);
`;

const ModalHeading = styled.h2`
  display: flex;

  font-size: 2.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  align-items: center;
  svg {
    margin-left: 0.5rem;
    height: 100%;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 32rem;
  display: flex;
  justify-content: center;
`;

const ErrorsContainer = styled.div`
  flex: 1;
  margin-bottom: 0.5rem;
  overflow-y: auto;
  width: 100%;
`;

const externalContentStyles = {
  height: '40%',
  width: '40%',
  padding: '0',
};

export const CopyToErrorModal: FC = () => {
  const dispatch = useAppDispatch();
  const { props } = useAppSelector((state) => state.modalReducer.copyToErrorModal);

  return (
    <Modal
      modalId="copyToErrorModal"
      externalContentStyles={externalContentStyles}
      headerType="error"
    >
      <CopyToModalContainer>
        <ModalHeading>
          Error
          <ErrorIcon />
        </ModalHeading>
        <ErrorsContainer>
          {props?.error && <ErrorBox errors={props.error.errors.map((error) => error.message)} />}
        </ErrorsContainer>
        <ButtonContainer>
          <ClassicButton
            width="10rem"
            variant={VARIANT.PRIMARY}
            onClick={() => dispatch(openModal({ modalId: 'copyToModal' }))}
          >
            Close
          </ClassicButton>
        </ButtonContainer>
      </CopyToModalContainer>
    </Modal>
  );
};
